<template>
  <div class="filter-bar" @click="select">
    <span>
      年份 {{ year }}
      <i class="caret"></i>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    var year = new Date().getFullYear()

    return {
      year
    };
  },
  methods: {
    select() {
      var me = this,
        year = new Date().getFullYear(),
        years = []
      for (let i = year - 20; i <= year; i++) {
        years.push({
          value: i,
          label: i + "年"
        });
      }
      me.$weui.picker(
        years,
        {
          title: "选择年份",
          defaultValue: [year],
          onConfirm: function (r) {
            me.year = r[0].value
            me.$emit("change", me.year);
          },
        }
      );
    }
  }
};
</script>

<style scoped>
.filter-bar {
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
}
.filter-bar span {
  margin: 0 auto;
}
</style>